var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlaystoreBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 202.5 60"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "PlaystoreBadge_svg__a",
    x1: 0.908,
    y1: 1.032,
    x2: -0.383,
    y2: 0.36,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "PlaystoreBadge_svg__b",
    x1: 1.077,
    y1: 0.729,
    x2: -1.307,
    y2: 0.729,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "PlaystoreBadge_svg__c",
    x1: 0.864,
    y1: -0.023,
    x2: -0.499,
    y2: -1.789,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "PlaystoreBadge_svg__d",
    x1: -0.186,
    y1: 2.701,
    x2: 0.423,
    y2: 1.909,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195 60H7.5A7.427 7.427 0 010 52.5v-45A7.427 7.427 0 017.5 0H195a7.427 7.427 0 017.5 7.5v45A7.427 7.427 0 01195 60z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195 1.2a6.338 6.338 0 016.3 6.3v45a6.338 6.338 0 01-6.3 6.3H7.5a6.338 6.338 0 01-6.3-6.3v-45a6.338 6.338 0 016.3-6.3zm0-1.2H7.5A7.522 7.522 0 000 7.5v45A7.427 7.427 0 007.5 60H195a7.427 7.427 0 007.5-7.5v-45A7.522 7.522 0 00195 0z",
    fill: "#a6a6a6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1 15.3a4.086 4.086 0 01-1.05 3 4.708 4.708 0 01-6.6 0A4.41 4.41 0 0162.1 15a4.41 4.41 0 011.35-3.3 4.41 4.41 0 013.3-1.35 3.994 3.994 0 011.8.45 3.266 3.266 0 011.35 1.05l-.75.75a2.8 2.8 0 00-2.4-1.05 2.985 2.985 0 00-2.4 1.05 3.09 3.09 0 00-1.05 2.55 3.09 3.09 0 001.05 2.55 3.862 3.862 0 002.4 1.05 3.29 3.29 0 002.55-1.05 2.484 2.484 0 00.75-1.8h-3.3v-1.2h4.35zm6.9-3.75h-4.05v2.85h3.75v1.05h-3.75v2.85H78v1.2h-5.25v-9H78zm4.95 7.95h-1.2v-7.95H79.2V10.5h6.3v1.05h-2.55zm6.9 0v-9h1.2v9zm6.3 0h-1.2v-7.95H92.4V10.5h6.15v1.05H96v7.95zm14.25-1.2a4.708 4.708 0 01-6.6 0 4.41 4.41 0 01-1.35-3.3 4.41 4.41 0 011.35-3.3 4.708 4.708 0 016.6 0 4.41 4.41 0 011.35 3.3 4.41 4.41 0 01-1.35 3.3zm-5.7-.75a3.54 3.54 0 002.4 1.05 2.985 2.985 0 002.4-1.05 3.619 3.619 0 001.05-2.55 3.09 3.09 0 00-1.05-2.55 3.54 3.54 0 00-2.4-1.05 2.985 2.985 0 00-2.4 1.05 3.619 3.619 0 00-1.05 2.55 3.09 3.09 0 001.05 2.55zm8.7 1.95v-9h1.35l4.35 7.05V10.5h1.2v9h-1.2l-4.65-7.35v7.35z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.15 32.7a6.311 6.311 0 00-6.45 6.45 6.4 6.4 0 006.45 6.45 6.311 6.311 0 006.45-6.45 6.223 6.223 0 00-6.45-6.45zm0 10.2a3.723 3.723 0 01-3.6-3.9 3.723 3.723 0 013.6-3.9 3.634 3.634 0 013.6 3.9 3.723 3.723 0 01-3.6 3.9zM88.2 32.7a6.311 6.311 0 00-6.45 6.45 6.4 6.4 0 006.45 6.45 6.311 6.311 0 006.45-6.45 6.223 6.223 0 00-6.45-6.45zm0 10.2a3.723 3.723 0 01-3.6-3.9 3.723 3.723 0 013.6-3.9 3.634 3.634 0 013.6 3.9 3.723 3.723 0 01-3.6 3.9zm-16.65-8.25v2.7H78a5.672 5.672 0 01-1.5 3.45 6.639 6.639 0 01-4.95 1.95 6.984 6.984 0 01-7.05-7.2 7.076 7.076 0 017.05-7.2 7.437 7.437 0 014.95 1.95l1.95-1.95a9.612 9.612 0 00-6.75-2.7 10.119 10.119 0 00-10.05 9.9 10.119 10.119 0 0010.05 9.9 8.632 8.632 0 006.9-2.85 9.03 9.03 0 002.4-6.3 5.625 5.625 0 00-.15-1.65zm68.1 2.1a5.828 5.828 0 00-5.4-4.05c-3.3 0-6 2.55-6 6.45a6.277 6.277 0 006.3 6.45 6.153 6.153 0 005.25-2.85l-2.1-1.5a3.656 3.656 0 01-3.15 1.8 3.254 3.254 0 01-3.15-1.95l8.55-3.6zm-8.7 2.1a3.644 3.644 0 013.3-3.75 2.653 2.653 0 012.4 1.35zM123.9 45h2.85V26.25h-2.85zm-4.5-10.95a4.939 4.939 0 00-3.45-1.5A6.445 6.445 0 00109.8 39a6.211 6.211 0 006.15 6.3 4.307 4.307 0 003.3-1.5h.15v.9c0 2.4-1.35 3.75-3.45 3.75a3.333 3.333 0 01-3.15-2.25l-2.4 1.05a6.188 6.188 0 005.7 3.75c3.3 0 6-1.95 6-6.6V33h-2.7zm-3.3 8.85a3.723 3.723 0 01-3.6-3.9 3.723 3.723 0 013.6-3.9 3.609 3.609 0 013.45 3.9 3.609 3.609 0 01-3.45 3.9zm36.6-16.65h-6.75V45h2.85v-7.05h3.9a5.857 5.857 0 100-11.7zm.15 9h-4.05V28.8h4.05a3.3 3.3 0 013.3 3.15 3.433 3.433 0 01-3.3 3.3zm17.25-2.7c-2.1 0-4.2.9-4.95 2.85l2.55 1.05a2.65 2.65 0 012.55-1.35 2.819 2.819 0 013 2.4v.15a5.95 5.95 0 00-2.85-.75c-2.7 0-5.4 1.5-5.4 4.2a4.394 4.394 0 004.65 4.2 4.221 4.221 0 003.6-1.8h.15V45h2.7v-7.2a5.677 5.677 0 00-6-5.25zm-.3 10.35c-.9 0-2.25-.45-2.25-1.65 0-1.5 1.65-1.95 3-1.95a5.8 5.8 0 012.55.6 3.493 3.493 0 01-3.3 3zm15.75-9.9l-3.15 8.1h-.15l-3.3-8.1h-3l4.95 11.4-2.85 6.3h2.85l7.65-17.7zm-25.2 12h2.85V26.25h-2.85z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 7.5a2.933 2.933 0 00-.6 2.1v33.15a2.967 2.967 0 00.75 2.1l.15.15 18.6-18.6v-.3z",
    transform: "translate(5 3.75)",
    fill: "url(#PlaystoreBadge_svg__a)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.05 28.55L22.9 22.4v-.45l6.15-6.15.15.15 7.35 4.2c2.1 1.2 2.1 3.15 0 4.35z",
    transform: "translate(11.45 7.9)",
    fill: "url(#PlaystoreBadge_svg__b)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.45 26.3l-6.3-6.3L10.4 38.75c.75.75 1.8.75 3.15.15z",
    transform: "translate(5.2 10)",
    fill: "url(#PlaystoreBadge_svg__c)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.45 20.114l-21.9-12.45c-1.35-.75-2.4-.6-3.15.15l18.75 18.6z",
    transform: "translate(5.2 3.586)",
    fill: "url(#PlaystoreBadge_svg__d)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 36.15l-21.75 12.3a2.453 2.453 0 01-3 0l-.15.15.15.15a2.453 2.453 0 003 0z",
    opacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 48.45a2.933 2.933 0 01-.6-2.1v.15a2.967 2.967 0 00.75 2.1v-.15zM48 31.95l-7.5 4.2.15.15L48 32.1a2.493 2.493 0 001.5-2.1c0 .75-.6 1.35-1.5 1.95z",
    opacity: 0.12
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 11.4L48 28.05c.9.6 1.5 1.2 1.5 1.95a2.493 2.493 0 00-1.5-2.1L18.75 11.25c-2.1-1.2-3.75-.3-3.75 2.1v.15c0-2.25 1.65-3.3 3.75-2.1z",
    opacity: 0.25,
    fill: "#fff"
  })));
}

export default SvgPlaystoreBadge;